import { createApp } from 'vue';
import App from './App.vue';
import { NConfigProvider, NDataTable, NButton } from 'naive-ui';
import naive from 'naive-ui';

const app = createApp(App);

app.use(naive);

app.use(NConfigProvider); // 添加这一行

app.component('NDataTable', NDataTable);
app.component('NButton', NButton);

app.mount('#app');